module.exports = __webpack_public_path__ + "03_glasses_brown.6b9af72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/03_glasses_brown.png
// module id = +0kY
// module chunks = 0